// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".watch-now-button--large ion-button[data-v-426c8fe4]{height:48px}.watch-now-button--slim ion-button[data-v-426c8fe4]{height:36px}.watch-now-button .basic-button[data-v-426c8fe4]:hover{background-color:#fbd446}", ""]);
// Exports
module.exports = exports;
